import { render, staticRenderFns } from "./DynamicSections.vue?vue&type=template&id=e44a5544&lang=pug&"
import script from "./DynamicSections.vue?vue&type=script&lang=js&"
export * from "./DynamicSections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports